import { useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { useForm } from 'react-hook-form';

import { Button, Input, Patterns, Tooltip } from '@treezor/design-system';

import { openModal } from '@/store/actions/core.actions';

import { IConfigPasswordModalProps } from './ConfigPasswordModal';

interface IConfigPasswordUrlFormState {
  passwordChangeRedirectUrl: string;
}

interface IConfigPasswordProps {
  passwordChangeRedirectUrl: string;
}

export const ConfigPassword = ({ passwordChangeRedirectUrl }: IConfigPasswordProps) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const defaultValues: IConfigPasswordUrlFormState = {
    passwordChangeRedirectUrl,
  };

  const {
    handleSubmit,
    watch,
    register,
    formState: { dirtyFields },
  } = useForm<IConfigPasswordUrlFormState>({ defaultValues });

  const onSubmit = (data: IConfigPasswordUrlFormState) => {
    dispatch(
      openModal<IConfigPasswordModalProps>('configPasswordModal', {
        passwordUrl: data.passwordChangeRedirectUrl,
        oldPasswordUrl: passwordChangeRedirectUrl,
      }),
    );
  };

  return (
    <div className="w-full">
      <div className="flex justify-between items-center mb-4 w-full">
        <h5 className="typo-h5-bold text-secondary">{t('pages.administration.configuration.password.title')}</h5>

        <Tooltip messageContent={t('pages.administration.configuration.password.tooltip')}>
          <Button
            type="button"
            id="update_password_url"
            onClick={handleSubmit(onSubmit)}
            color="default"
            disabled={!Boolean(dirtyFields.passwordChangeRedirectUrl)}
          >
            {t('pages.administration.configuration.password.forms.saveBtn')}
          </Button>
        </Tooltip>
      </div>
      <div className="flex-1 w-[50%]">
        <Input
          type="text"
          label={t('pages.administration.configuration.password.forms.passwordConfig')}
          value={watch('passwordChangeRedirectUrl')}
          {...register('passwordChangeRedirectUrl', { pattern: Patterns.url })}
        />
      </div>
    </div>
  );
};
